import { inject } from '@angular/core';
import {
  DIRECT_TICKETS_SCHEMA,
  IBuyResponse,
  IDirectTicket,
  IGuestTransactionRequest,
  IPurchase,
  ITransactionRequest,
} from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../../builder/rest/rest-call.builder';
import { AppConfigService } from '../../../app-config.service';
import { IListGateway } from '../../gateways';

export class ActiveFixedPriceTicketsGateway implements IListGateway<
  number,
  IApiResponse<IDirectTicket[]>
> {
  private readonly listRestCallBuilder: RestCallBuilder<IDirectTicket[]> =
    new RestCallBuilder<IDirectTicket[]>([]);
  private readonly restCallBuilder: RestCallBuilder<
    ITransactionRequest,
    IPurchase
  > = new RestCallBuilder<ITransactionRequest, IPurchase>({
    referenceId: '',
    purpose: '',
    paymentMethodId: '',
    purchase: {
      datetime: '',
      currency: 'EUR',
      totalNet: 0,
      totalSum: 0,
      totalVat: 0,
      articles: [],
    },
    urlToCancel: '',
    urlToError: '',
    urlToInitiator: '',
  });
  private readonly restCallBuilderGuest: RestCallBuilder<
    IGuestTransactionRequest,
    IBuyResponse
  > = new RestCallBuilder<IGuestTransactionRequest, IBuyResponse>({
    providerResponse: null,
  });
  private readonly configService: AppConfigService = inject(AppConfigService);

  list(serviceAreaId: number): Observable<IApiResponse<IDirectTicket[]>> {
    return this.listRestCallBuilder
      .getExternal(
        //@TODO remove /all once testing winds down
        this.configService.get().general.directTicketUrl +
          '/tickets/fixed-price/all',
        {
          serviceAreaId: serviceAreaId,
        }
      )
      .validate(API_RESPONSE_SCHEMA(DIRECT_TICKETS_SCHEMA), 'DirectTicket.list')
      .handleMessages()
      .build();
  }

  placeOrder(
    request: ITransactionRequest
  ): Observable<IApiResponse<IPurchase>> {
    return this.restCallBuilder
      .postExternal(
        `${this.configService.get().general.directTicketUrl}/transaction`,
        request
      )
      .handleMessages()
      .build();
  }

  placeGuestOrder(
    request: IGuestTransactionRequest
  ): Observable<IApiResponse<IBuyResponse>> {
    return this.restCallBuilderGuest
      .postExternal(
        `${this.configService.get().general.directTicketUrl}/transaction/guest`,
        request
      )
      .handleMessages()
      .build();
  }
}
